import * as React from "react";
import { Point } from "ol/geom";
import { config } from "../config";
import i18next from "i18next";
import { Map } from "ol";

export const HomeButton = ({ map }: { map: Map }): JSX.Element => {
    const onClick = () => {
        const view = map.getView();
        //@ts-ignore
        if (!view || !view.viewportSize_) {
            return;
        }
        //@ts-ignore
        const resolutionX = config.default.extentSize[0] / view.viewportSize_[0];
        //@ts-ignore
        const resolutionY = config.default.extentSize[1] / view.viewportSize_[1];
        const zoom = view.getZoomForResolution(resolutionX > resolutionY ? resolutionX : resolutionY);

        view.fit(new Point(config.default.center), {
            maxZoom: zoom,
            duration: 1000
        });
    };

    return (
        <div className="geolite-map-button home-container ol-unselectable ol-control">
            <div className="home-button" onClick={onClick} title={i18next.t("mapHome")}>
                <span className="icon-geolite-home" />
            </div>
        </div>
    );
};
